module.exports = __webpack_public_path__ + "img/flux360-Tutorial_scroll.f7b17f99.svg";